import {
  Maybe as HygraphMaybe,
  VerticalSide as HygraphVerticalSide,
} from '@/lib/types';

import { VerticalSide } from '@/enums/vertical-side';

export default function verticalSideTransformer(
  props: HygraphMaybe<HygraphVerticalSide> | undefined
) {
  switch (props) {
    case HygraphVerticalSide.Top:
      return VerticalSide.TOP;
    case HygraphVerticalSide.Bottom:
      return VerticalSide.BOTTOM;
    default:
      return undefined;
  }
}
